
// Helpers
import { isWeb, isNative, isMobileWeb } from './extract-config.helper';
import { hasAccess } from './permission.helper';

// Constants
import { APP_CONFIG } from '../constants';

/**
 * Obtiene la url inicial de acuerdo a la plataforma
 * @param { Array String } permissions Permisos configurados desde Auth0
 */
export const getUrlInitByPlatform = (permissions, network) => {

    // Si es Web o MobileWeb
    if ( (isWeb() || isMobileWeb())
    ) {

        // Si es MobileWeb y no tiene conexión a internet
        if ( isMobileWeb() && network && !network.connected ) {

            return APP_CONFIG.PAGES.OFFLINE.path;
        }
        
        // Si no tiene acceso a la página de document
        if ( !hasAccess(APP_CONFIG.PAGES.DOCUMENT.permissions, permissions) ) {
            return APP_CONFIG.PAGES.HOME.path;
        }
        else {

            return APP_CONFIG.PAGES.REDIRECT.web;
        }        
    }

    // Si es Mobile y no tiene conexión a internet
    if ( network && !network.connected ) {

        return APP_CONFIG.PAGES.OFFLINE.path;
    }

    // Si es mobile y no tiene acceso a qr scan
    if ( !hasAccess(APP_CONFIG.PAGES.QR_SCAN.permissions, permissions) ) {
    
        // Si tiene acceso a document, lo redirijo allí
        if ( hasAccess(APP_CONFIG.PAGES.DOCUMENT.permissions, permissions) ) {
            
            return APP_CONFIG.PAGES.DOCUMENT.path;
        }
        else {

            return APP_CONFIG.PAGES.HOME.path;
        }
    }
    else {

        const pathName = window.location.pathname;
        if ( pathName === APP_CONFIG.PAGES.LOGIN.path || pathName === APP_CONFIG.PAGES.QR_SCAN.path ) {

            return APP_CONFIG.PAGES.REDIRECT.mobile;
        }

        // Si tiene acceso a document, lo redirijo allí
        if ( hasAccess(APP_CONFIG.PAGES.DOCUMENT.permissions, permissions) ) {
            
            return APP_CONFIG.PAGES.DOCUMENT.path;
        }

        return APP_CONFIG.PAGES.REDIRECT.mobile;
    }

}